<script setup lang="ts">
interface Props {
  borderBottom?: boolean;
}

withDefaults(defineProps<Props>(), {
  borderBottom: true,
});
</script>

<template>
  <div class="blocks-wrapper" :class="{ 'with-border': borderBottom }">
    <slot></slot>
  </div>
</template>

<style>
.blocks-wrapper > * {
  padding: 16px 0;
}

.blocks-wrapper.with-border > * {
  padding: 32px 0;
}

.blocks-wrapper.with-border > *:not(:last-child) {
  border-bottom: 1px solid var(--color-neutral-300);
}
</style>
